/** @module csi/heading/Property */
define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/heading/Renderer",
	"csi/locale",
	"csi/types",
	"csi/widget/Tooltip",
	"csi/xml"
], function(declare, csiHeading, Renderer, locale, types, Tooltip, xml) {

	return declare(Renderer, {
		/**
		 * Handle special cases when filtering by node properties
		 */
		getQuerySpec: function(ctx, h, spec) {
			// if property is a ref (Created By or Modified By), then treat as a string
			var type = (spec.type == xml.ATTR_REF) ? xml.ATTR_STRING : spec.type;

			// if displaying name, then filter by attribute rather than property (not sure if this is still valid,
			// but Name property has restricted length while Node Name attribute does not) 
			var id = (h.m_prop == xml.PROP_NAME) ? xml.ATTR_NAME : null;
			var prop = id ? null : h.m_prop;
			var index;

			if (id && spec.rc && spec.rc.isLocalizedItem) {
				id = xml.FILTER_LOCALIZED_NAME;
				index = ctx.locale || locale.getLocale();
			}

			// FIX: for now support both extended and non-extended paths, but based on all testing,
			// extended path always exists; in future it will be mandatory
			var ep = spec.getExtendedPath();
			var path = h.m_path;

			if (ep) {
				// use extended path syntax in query path
				path = ep.getQueryPath();
			} else if (h.isMatrixSubHeading()) {
				// if heading is in matrix, then prepend path to matrix 
				path = xml.path(h.m_parent.matrixGroupPath, path);
			}

			// determine format for property
			var format;

			if (type == xml.ATTR_TIME) {
				format = types.FORMAT_DATETIME;
			} else if (h.m_prop == xml.PROP_TYPE) {
				format = types.FORMAT_TYPE;
			}

			// determines the operator for property
			const ops = csiHeading.QUERY_OPS[spec.type];

			return {
				allowFilteringBySelectionOfExistingValues: true,
				id,
				index,
				path,
				prop,
				ops,
				relative: true,
				ren: csiHeading.getRenderer(type, format),
				type
			};
		},

		isTabStop: function(/*Context*/ctx, /*Heading*/h) {
			// summary: no editing lists through keyboard by default
			return false;
		},

		_getCSS: function(/*String*/type, /*String?*/format) {
			// summary: use string CSS as default
			return "attrString";
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: get property value for context
			return xml.nodeGetProperty(ctx.getNode(), h.m_prop);
		},

		/**
		 * @override
		 *  add tooltip for the node property
		 */
		toTooltip: function(ctx, h, tooltip) {
			// add heading tooltip
			if (ctx.view.useMuiTooltipStyling) {
				const customFieldValue = this.headingToText(ctx, h);
				const customFieldTooltip = h?.m_tooltip ?? "";
				if (customFieldValue !== "" || customFieldTooltip !== "") {
					tooltip.addContent(Tooltip.formatCustomField(customFieldValue, customFieldTooltip));
				}
			}
		},
	});
});